/*
 * This file is a generated Typescript file for GRPC Gateway, DO NOT MODIFY
 */

import * as fm from "../../../fm"


/**
 * Сервис реализует функционал выдачи тэгов.
 * Цель: сделать сервис обогащающий пользователей дополнительными классифицирующими метками.
 * Тэги не хранятся в базе, а вычисляются на лету из данных о пользователе.
 * Представляют из себя строку вида тэг1_значение или тэг2_значение.тэг3_значение (до 10 объединений через точку)
 */

/**
 * Сервис тэгов
 */
export class TagServiceClient {
  /**
   * Конструктор сервиса
   * @param host Адрес хоста
   * @param token Токен доступа
   */
  constructor(
    public host = "",
    public token = ""
  ) { }

  /**
   * Метод получения списка тэгов.
   * Метод доступен для: master, slave
   */
  GetTagList = (req?: GetTagListRequestDto, init?: RequestInit): Promise<GetTagListResponseDto[]> => {
    return fm.list<GetTagListRequestDto, GetTagListResponseDto>(`${this.host}/tag/api/v1/tag/list${fm.buildQuery(req)}`, {...init, method: "GET", ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }
}

/**
 * Запрос получения списка тэгов
 */
export type GetTagListRequestDto = {
}
/**
 * Ответ на запрос получения списка тэгов
 */
export type GetTagListResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Пользовательский тэг
   */
  readonly data: string
}>
/**
 * Дескриптор
 */
export const descriptor = {
  /**
   * Запрос получения списка тэгов
   */
  "GetTagListRequest": {
    "kind": "class",
    "text": "Запрос получения списка тэгов",
  },
  /**
   * Ответ на запрос получения списка тэгов
   */
  "GetTagListResponse": {
    "kind": "class",
    "text": "Ответ на запрос получения списка тэгов",
    "fields": {
      /**
       * Пользовательский тэг
       */
      "data": {
        "type": "string",
        "text": "Пользовательский тэг",
      },
    },
  },
}